<div class="d-flex">
    <div class="col-4 detail-name" style="font-size: 150%;">Start Date</div>
  </div>
  <div class="d-flex">
    <div class="col-3 mb-3"><app-datepicker [(model)]="schoolStart" (modelChange)="updateEEUReport()"></app-datepicker></div>
  </div>
  <table class="eeu-report">
    <thead>
      <th>
        Student
      </th>
      <th>
        {{getDisplayDate()}}
      </th>
      <th>
        {{getDisplayDate(1)}}
      </th>
      <th>
        {{getDisplayDate(2)}}
      </th>
      <th>
        {{getDisplayDate(3)}}
      </th>
      <th>
        {{getDisplayDate(4)}}
      </th>
      <th>
        {{getDisplayDate(5)}}
      </th>
      <th>
        {{getDisplayDate(6)}}
      </th>
      <th>
        <i>On Track</i>
      </th>
      <th>
        {{getDisplayDate(7)}}
      </th>
      <th>
        {{getDisplayDate(8)}}
      </th>
      <th>
        {{getDisplayDate(9)}}
      </th>
      <th>
        {{getDisplayDate(10)}}
      </th>
      <th>
        {{getDisplayDate(11)}}
      </th>
      <th>
        {{getDisplayDate(12)}}
      </th>
      <th>
        {{getDisplayDate(13)}}
      </th>
      <th>
        <i>On Track</i>
      </th>
      <th>
        {{getDisplayDate(14)}}
      </th>
      <th>
        {{getDisplayDate(15)}}
      </th>
      <th>
        {{getDisplayDate(16)}}
      </th>
      <th>
        {{getDisplayDate(17)}}
      </th>
      <th>
        {{getDisplayDate(18)}}
      </th>
      <th>
        {{getDisplayDate(19)}}
      </th>
      <th>
        {{getDisplayDate(20)}}
      </th>
      <th>
        <i>Done</i>
      </th>
    </thead>
    <tbody>
      <tr *ngFor="let student of eeuReport">
        <td>
          <a href="/classes/{{organizationID}}/class/{{classID}}/students/{{student.StudentID}}">{{student.Name}}</a>
        </td>
        <td *ngFor="let day of student.Days.slice(0,7)">
          {{day.Activities || "-"}}
        </td>
        <td [ngClass]="isOnTrack(student, 7, 18) ? 'on-track' : 'off-track'">
          {{getRunningActivityCount(student, 7)}}
        </td>
        <td *ngFor="let day of student.Days.slice(7,14)">
          {{day.Activities || "-"}}
        </td>
        <td [ngClass]="isOnTrack(student, 14, 35) ? 'on-track' : 'off-track'">
          {{getRunningActivityCount(student, 14)}}
        </td>
        <td *ngFor="let day of student.Days.slice(14,21)">
          {{day.Activities || "-"}}
        </td>
        <td [ngClass]="isOnTrack(student, 21, 52) ? 'on-track' : 'off-track'">
          {{getRunningActivityCount(student, 21)}}
        </td>
      </tr>
    </tbody>
  </table>